import React, { Fragment, useState} from "react";

import {GridToolbar} from "@progress/kendo-react-grid";

// components
import NestedTable from "../../../Common/Orders/NestedTable";
import BasicTable from "../../../Common/Orders/BasicTable";
import {toFixedDate, toMoneyValue, toPercentValue} from "../../../../utils/reactFunctions";

interface Props {
  tableData: any[];
  fetchingOrders: boolean;
  exportButton: () => JSX.Element;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  featuresAllowed: string[];
}

export default (props: Props) => {
  const initialSortValue = [
    { field: null, dir: null },
  ];
  const [sort, setSort] = useState(initialSortValue);
  const [featuresAllowed, setFeaturesAllowed] = React.useState<string[]>(props.featuresAllowed);
  
  const tableConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "id",
      },
      {
        headTitle: 'ID ERP',
        rowValue: "erpOrderId",
      },
      {
        headTitle: 'ID SOURCE',
        rowValue: "originOrderId",
      },
      {
        headTitle: 'FECHA',
        rowValue: "orderDate",
        custom: toFixedDate,
      },
      {
        headTitle: 'ORIGEN',
        rowValue: "originSystemCode",
      },
      {
        headTitle: 'ID VENDEDOR',
        rowValue: "sellerId",
      },
      {
        headTitle: 'NOMBRE VENDEDOR',
        rowValue: "sellerName",
      },
      {
        headTitle: 'ID CLIENTE',
        rowValue: "clientId",
      },
      {
        headTitle: 'CLIENTE',
        rowValue: "clientName",
      },
      {
        headTitle: 'CANAL',
        rowValue: "clientChannel",
      },
      {
        headTitle: 'TOTAL NETO',
        rowValue: "totalNetPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'IVA + IMP INTERNO',
        rowValue: "totalTaxes",
        custom: toMoneyValue
      },
      {
        headTitle: 'PERCEPCIONES',
        rowValue: "totalPerceptions",
        custom: toMoneyValue
      },
      {
        headTitle: 'MONTO',
        rowValue: "total",
        custom: toMoneyValue
      },
      {
        headTitle: 'ESTADO',
        rowValue: "erpState",
      },
      {
        headTitle: 'N° FACTURA',
        rowValue: "invoiceId",
      },
      {
        headTitle: 'TIPO OPERACION AXUM',
        rowValue: "axumOperationType",
      },
    ];
  };

  const detailConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "articleId",
      },
      {
        headTitle: 'ARTÍCULO',
        rowValue: "articleName",
      },
      {
        headTitle: 'BULTOS',
        rowValue: "bundles",
      },
      {
        headTitle: 'UNIDADES ADICIONALES',
        rowValue: "units",
      },
      {
        headTitle: 'BULTOS SIN CARGO',
        rowValue: "noFeeBundles",
      },
      {
        headTitle: 'UNIDADES SIN CARGO',
        rowValue: "noFeeUnits",
      },
      {
        headTitle: 'PRECIO BRUTO',
        rowValue: "totalGrossPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'BONIFICACIONES',
        rowValue: "totalBonusAndDiscount",
        custom: toPercentValue
      },
      {
        headTitle: 'PRECIO NETO',
        rowValue: "totalNetPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'IMPUESTOS',
        rowValue: "totalTaxes",
        custom: toMoneyValue
      },
      {
        headTitle: 'PRECIO FINAL',
        rowValue: "totalFinalPrice",
        custom: toMoneyValue
      },
    ];
  };

  const orderDetail = (props: any) => {
  
    const data = props.dataItem.detail;
    return (
      <BasicTable
        tableConfig={detailConfig('CÓDIGO ART')}
        parentData= {props.dataItem}
        tableData={data}
        loading={false}
        featuresAllowed={featuresAllowed}
      />
    );
  };

  return (
      <Fragment>
        <GridToolbar>
          {props.exportButton && props.exportButton()}
        </GridToolbar>
        <NestedTable
            tableConfig={tableConfig('ID AXUM')}
            tableData={props.tableData}
            loading={props.fetchingOrders}
            detailComponent={orderDetail}
            requestNewPage={props.sendFilters}
            take={props.take}
            skip={props.skip}
            total={props.total}
            sort={sort}
            setSort={setSort}
            featuresAllowed={props.featuresAllowed}
        />
      </Fragment>
  );
};
